import styled from "styled-components";

export const ShowIssuesReportsCommentsWrapper = styled.div`
    .comments{
        border: 1px solid;
        border-radius: 5px;
        padding: 1% 2%;
        margin-top:1%;
    }
    .issueAt{
        margin: 0;
        font-size: 16px;
        font-weight: bold;
    }
    .comment{
        margin:0;
    }
    .note{
        font-size: 14px;
        color: red;
        font-weight: bold;
    }
    .imagesDiv{
        width: 100%;
    text-align: center;
    margin-top: 2%;
    }
    .image{
        max-width:50%;
        max-height: 15rem;
    }
`;